import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RitualConfig } from '../../helpers/ritual';
import { CommonIcon } from '../common/CommonIcon';
import { RitualCardIcon } from './RitualCardIcon';

interface RitualCardCompletingStateProps {
    config: RitualConfig;
    completedXp: number;
    totalCount: number;
}

export const RitualCardCompletingState: FC<RitualCardCompletingStateProps> = ({
    config,
    completedXp,
    totalCount,
}) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ padding: '12px' }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" gap={1}>
                    <RitualCardIcon icon={config.icon} backgroundColor="rgba(255, 255, 255, 0.2)" />
                    <Stack direction="column" gap={0.25}>
                        <Text
                            style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: 'white',
                            }}
                        >
                            {config.title}
                        </Text>
                        <Stack direction="row" alignItems="center" gap={1}>
                            <Text
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: 'white',
                                }}
                            >
                                +{completedXp} XP
                            </Text>
                            <Text style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.7)' }}>•</Text>
                            <Text
                                style={{
                                    fontSize: '13px',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                }}
                            >
                                {t('ritual.completedTaskCount', { count: totalCount })}
                            </Text>
                        </Stack>
                    </Stack>
                </Stack>
                <CommonIcon
                    icon="check_circle"
                    type="filled"
                    size={30}
                    color="white"
                />
            </Stack>
        </Box>
    );
};
